<modal closable="!saving">
  <span header>{{'Tạo phiếu chi thanh toán công nợ cho xưởng' | lang}}</span>
  <p>{{'Ngày thanh toán' | lang}}</p>
  <input [disabled]="saving" class="input text-primary text-center bold pointer" type="text" readonly="readonly" value="{{payment.Stamp | date : 'dd-MM-yyyy'}}" (click)="editStamp()"/>
  <p>{{'Số tiền Việt chuyển đi' | lang}} (đ)</p>
  <number-input [disabled]="saving" class="text-center" [value]="payment.SendAmount" (change)="update($event.target, 'SendAmount')"></number-input>
  <p>{{'Số tiền Trung ghi nhận' | lang}} (¥)</p>
  <number-input [disabled]="saving" class="text-center" [value]="payment.ReceiveAmount" (change)="update($event.target, 'ReceiveAmount')"></number-input>
  <p>{{'Tỷ giá quy đổi'}}</p>
  <div class="input text-danger" *ngIf="payment.ReceiveAmount == 0 || payment.SendAmount == 0">{{'không rõ' | lang}}</div>
  <div class="input text-success" *ngIf="payment.ReceiveAmount > 0 && payment.SendAmount > 0">{{payment.SendAmount / payment.ReceiveAmount | number : '1.0-2' : 'en-US'}}<vnd-per-cny></vnd-per-cny></div>

  <div class="flex">
    <button class="text-white bg-success" [disabled]="!savable" (click)="save()"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
    <button class="text-white bg-warning" (click)="close()"><i class="fa fa-arrow-left"></i><span>{{'Quay lại' | lang}}</span></button>
  </div>
</modal>
